import { RootState } from 'store/rootReducer';

export const ThirdPartyLicensesContentSelector = (state: RootState) => state.content.thirdPartyLicenses;
